import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import { motion } from 'framer-motion';
import '../styles/LegalPages.scss';

const Imprint = () => {
    return (
        <div className="legal-page imprint-page">
            <motion.div
                className="page-header"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
            >
                <div className="header-background" />
                <Container>
                    <motion.div
                        initial={{ y: -30, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.2, duration: 0.8 }}
                        className="header-content"
                    >
                        <Typography variant="h1">Impresszum</Typography>
                        <Typography variant="subtitle1">
                            Cégünk hivatalos adatai
                        </Typography>
                    </motion.div>
                </Container>
            </motion.div>

            <Container>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 0.6 }}
                >
                    <Paper elevation={3} sx={{ p: 4, mt: -8, mb: 6, borderRadius: 2 }}>
                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                Cégadatok
                            </Typography>
                            <Typography paragraph>
                                <strong>Cégnév:</strong> Toronyszerver KFT.<br />
                                <strong>Székhely:</strong> 2230 Gyömrő, Állomás utca 15.<br />
                                <strong>Cégjegyzékszám:</strong> [Cégjegyzékszám]<br />
                                <strong>Adószám:</strong> [Adószám]<br />
                                <strong>EU adószám:</strong> [EU adószám]<br />
                                <strong>Bankszámlaszám:</strong> [Bankszámlaszám]<br />
                                <strong>Számlavezető bank:</strong> [Bank neve]
                            </Typography>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                Elérhetőségek
                            </Typography>
                            <Typography paragraph>
                                <strong>Levelezési cím:</strong> 2230 Gyömrő, Állomás utca 15.<br />
                                <strong>Telefon:</strong> +36 70 618 5311<br />
                                <strong>Email:</strong> iroda@toronyszerver.hu<br />
                                <strong>Weboldal:</strong> www.toronyszerver.hu
                            </Typography>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                Cégvezetés
                            </Typography>
                            <Typography paragraph>
                                <strong>Ügyvezető:</strong> Rácz Jenő<br />
                                <strong>Képviseletre jogosult:</strong> Rácz Jenő
                            </Typography>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                Tevékenységi körök
                            </Typography>
                            <Typography paragraph>
                                <strong>Főtevékenység:</strong> [Főtevékenység TEÁOR száma és megnevezése]<br />
                                <strong>További tevékenységek:</strong>
                            </Typography>
                            <ul>
                                <li>Ipari létesítmények kivitelezése</li>
                                <li>Kereskedelmi ingatlanok kivitelezése</li>
                                <li>Toronyépítés</li>
                                <li>Felújítási munkálatok</li>
                                <li>Infrastrukturális fejlesztések</li>
                            </ul>
                        </Box>

                        <Box mb={4}>
                            <Typography variant="h5" gutterBottom color="primary">
                                Tárhelyszolgáltató adatai
                            </Typography>
                            <Typography paragraph>
                                <strong>Szolgáltató neve:</strong> [Szolgáltató neve]<br />
                                <strong>Székhely:</strong> [Szolgáltató címe]<br />
                                <strong>Email:</strong> [Szolgáltató email]<br />
                                <strong>Telefon:</strong> [Szolgáltató telefon]
                            </Typography>
                        </Box>

                        <Box>
                            <Typography variant="h5" gutterBottom color="primary">
                                Szakmai felügyeleti szervek
                            </Typography>
                            <Typography paragraph>
                                <strong>Építési tevékenység:</strong><br />
                                [Illetékes építésfelügyeleti hatóság neve és elérhetősége]
                            </Typography>
                            <Typography paragraph>
                                <strong>Kereskedelmi tevékenység:</strong><br />
                                [Illetékes kereskedelmi hatóság neve és elérhetősége]
                            </Typography>
                        </Box>
                    </Paper>
                </motion.div>
            </Container>
        </div>
    );
};

export default Imprint; 